import React from 'react';
import {Map, List} from 'immutable';
import {quantityInputStyle, mobileCheckoutInputStyle} from './styles';
import {getCommerceDataProperty} from './ContextUtils';
import {
  COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR,
  COMMERCE_CART_PUBLISHED_SITE_ACTIONS,
  DATA_ATTR_COMMERCE_SKU_ID,
} from '@packages/systems/commerce/constants';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {TRecord} from '@packages/systems/wfdl-ast';
import {extraAtomFields} from '@packages/shared/constants/Atoms';
import {defaultIntegratedTypes} from '@packages/utilities/integrated-types';

const getSkuId = getCommerceDataProperty(['sku', 'id']);
const getItemCount = getCommerceDataProperty('count', 0);

const CommerceCartQuantity = Atom.createRender(
  ({attributes, classes, context, generateAttributes}) => {
    const quantity = getItemCount(context);
    const skuId = getSkuId(context);
    const domAttrs = generateAttributes(attributes, classes);
    return (
      <input
        {...domAttrs}
        required
        pattern="^[0-9]+$"
        inputMode="numeric"
        type="number"
        name="quantity"
        defaultValue={quantity}
        autoComplete="off"
        {...{
          [COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR]:
            COMMERCE_CART_PUBLISHED_SITE_ACTIONS.UPDATE_ITEM_QUANTITY,
          [DATA_ATTR_COMMERCE_SKU_ID]: skuId,
        }}
      />
    );
  }
);

const staticBindings = Map({
  value: List([
    Map({
      slug: 'count',
      type: 'Number',
      filter: 'numberPrecision|0|numberPrecision',
    }),
  ]),
  [DATA_ATTR_COMMERCE_SKU_ID]: List([
    Map({
      slug: 'sku',
      type: 'ItemRef',
    }),
    Map({
      id: 'id',
      slug: 'id',
      type: 'PlainText',
    }),
  ]),
});

// eslint-disable-next-line unused-imports/no-unused-vars, unused-imports/no-unused-vars
const {attr, ...rest} = defaultIntegratedTypes;

const config = Atom.create({
  displayName: 'Cart Quantity',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Input')),
  },
  dataType: TRecord(rest, extraAtomFields),
  showEmpty: false,
  constraints: {
    ancestors: [{is: 'CommerceCartItem', rule: 'ExactlyOne'}],
  },
  style: {
    base: {
      main: quantityInputStyle,
      tiny: mobileCheckoutInputStyle,
    },
  },
  render: CommerceCartQuantity,
  staticBindings,
});

export default config;
